import "mapbox-gl/dist/mapbox-gl.css";
import React from "react";
import { css } from "emotion";
import Fade from "react-reveal/Fade";

import Container from "components/shared/Container";
import GetInTouch from "components/contact/GetInTouch";
import Map from "components/map/Map";
import ContactForm from "components/contact/ContactForm";

import styleConfig from "styles/styleConfig";

const { colors, margin, padding, fontSize, transition, screens } = styleConfig;

const getInTouchStyle = css`
  background-color: ${colors.gray[100]};
  border: 1px solid ${colors.gray[200]};
  margin: ${margin[8]} 0;
  .container {
    padding: ${padding[4]};
  }
  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &#get-in-touch {
      h1 {
        margin: ${margin[4]} 0;
        font-size: ${fontSize.md};
        text-transform: uppercase;
      }
      p {
        display: flex;
        align-items: center;
        margin: ${margin[2]} 0;
        color: ${colors.gray[600]};
        &.head {
          margin-top: ${margin[6]};
        }
        &:not(.head) {
          margin-left: ${margin[4]};
        }
        strong {
          color: ${colors.black};
        }
      }
      a {
        color: ${colors.primary[300]};
        transition: ${transition.default};
        &:hover {
          color: ${colors.primary[600]};
        }
      }
      svg {
        height: 1rem;
      }
    }
  }
  #map > div {
    width: 500px !important;
  }
  @media (max-width: ${screens.MOBILE_WIDTH}px) {
    .content {
      flex-direction: column;
    }
    #map > div {
      width: 100% !important;
    }
  }
`;

const contactFormStyle = css`
  margin: ${margin[8]} 0;
  .container {
    padding: ${padding[4]};
  }
  .content {
    &#contact {
      h1 {
        margin: ${margin[4]} 0;
        font-size: ${fontSize.md};
        text-transform: uppercase;
      }
      p {
        margin: ${margin[2]} 0;
        color: ${colors.gray[600]};
        strong {
          color: ${colors.black};
        }
      }
      a {
        color: ${colors.primary[300]};
        transition: ${transition.default};
        &:hover {
          color: ${colors.primary[600]};
        }
      }
    }
  }
`;

interface Props {}

const Contact: React.FC<Props> = () => {
  return (
    <Fade bottom>
      {/* GET IN TOUCH */}
      <div className={getInTouchStyle}>
        <Container className="container">
          <div id="get-in-touch" className="content">
            {/* <Form /> */}
            <div>
              <GetInTouch />
            </div>
            <div>
              <Map />
            </div>
          </div>
        </Container>
      </div>
      {/* CONTACT */}
      <div className={contactFormStyle}>
        <Container className="container">
          <div id="contact" className="content">
            <div>
              <ContactForm />
            </div>
          </div>
        </Container>
      </div>
    </Fade>
  );
};

export default Contact;
